// extracted by mini-css-extract-plugin
export var customDots = "Slider-module--customDots--2cb05";
export var mobilePagination = "Slider-module--mobilePagination--50ab1";
export var root = "Slider-module--root--d0235";
export var spacing = "Slider-module--spacing--ab70a";